<template lang="pug">
  model-form(
        ref="form"
        reset-text="limpiar"
        submit-text="Continuar"
        title="Crear producto"
        :fields="formFields"
        v-model="formData"
        @reset="resetForm"
        @submit="submit"
        )
</template>

<script>
import { ModelForm } from '@/components/reusable_components/next'
import FieldsCreate from './fields'
/* vuex */
import {mapActions} from 'vuex'
/* model */
import ItemModel from '@/models/Warehouse/WhItem'
/* services */
import Translator from '@/services/translator'
export default {
  name: 'comercial-information',
  props: {
    // value:{
    //   type: Object,
    //   required: true,
    // },
    product:{
      type: Object,
    },
    branchOfficeId:{
      type: Array,
      required: true,
    },
  },
  data: function(){
    return {
      formData: {},
      formFields: FieldsCreate,
    }
  },
  //computed: {},
  methods: {
    // -- UI Modification
    // -- Data fetching
    // -- Data handling and transformations
    submit() {
      this.$refs.form.setWait(true).then(this.update)
    },
    /*
     */
    update(data) {
      
      let branchData = this.getBranchOfficeData(data)
      let updateInfo = this.getUpdateInfo(data,branchData)
      //
      let model = new ItemModel({id:this.product.product_id})
      model.sync(updateInfo)
      .then(r=>this.successUpdate(updateInfo))
      .catch(this.error)
      .then(this.$refs.form.setWait)
    },
    /*
     */
    getBranchOfficeData(comercial){
      let branchId= this.branchOfficeId
      return branchId.map(id=>{
        let branch={}
        branch.cost_price = comercial.cost_price
        branch.g_branch_office_id = id
        branch.gains_margin = comercial.gains_margin
        branch.sale_price = comercial.sale_price
        branch.warranty_days = comercial.warranty_days
        branch.minimum_stock = 0
        branch.maximum_stock = 0
        branch.critical_stock = 0
        return branch
      })
    },
    /*
     */
    getUpdateInfo (data,branchData){
      return {
        ...this.product, 
        branch_office_data:branchData,
        warranty_days : data.warranty_days || 0,
        is_consumable : data.is_consumable,
        is_salable : data.is_salable,
        is_tax_free :data.is_tax_free,
        //hard code data
        is_inventoriable : false,
        is_repackaged : false,
        is_seasonal : false,
        uom_quantity : 1, 
        wh_unit_of_measurement_id:1,
        have_decimal_quantity : false,

      }
    },
    /*
     */
    successUpdate(info) {
      this.$emit('comercialInfo',info)
      this.setSnackbar({
          type: 'success',
          title: 'Éxito',
          message: 'Información comercial creada exitosamente',
          timeout: 3000,
      })
    },
    error(error) {
    
      this.setSnackbar({
          type: 'error',
          title: 'Error',
          message: Translator(ItemModel, error.response.data),
          timeout: 15000,
      })
    },
    resetForm() {
        this.formData = {}
        this.formFields[0].props.items = []
    },
    // -- Validations and Error handling
    // -- Other functions
    // -- Vuex mappings
    ...mapActions('SnackbarModalModule', {
      setSnackbar: 'setSnackbar',
    }),
  },
  // watch: {},
  components: {
    'model-form' : ModelForm,
  },
  // mixins: [],
  // filters: {},
  // -- Lifecycle Methods
  beforeMount(){
    this.formData.is_salable = true
  }
  // -- End Lifecycle Methods
}
</script>

<style lang="scss">
  
</style>